<template>
  <div style="width:181px;">
    <v-list dense>
      <v-list-item
        v-for="(item, i) in items"
        :key="i"
        ripple
        link
        @click="applySelection(item)"
      >
        <span class="pl-2">
          {{ item.label }}
        </span>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
  export default {
    name: 'SingleSelectFilter',
    props: {
      filterKey: String,
      items: {
        type: Array,
        validator: arr => arr.every(item => !!item.label && !!item.filter),
      },
    },
    methods: {
      applySelection ({ value, operator = '=' }) {
        const payload = { key: this.filterKey, operator, value }
        this.$emit('select-filter', payload)
        // Force closes menu after selection
        this.$parent.$parent.save()
      },
    },
  }
</script>
